import { generateTypes } from '../../utils/HttpReducerHelper';

const createSnapshot = generateTypes('MONITOR_CLIENT', 'CREATE_SNAPSHOT');
const snapshot = generateTypes('MONITOR_CLIENT', 'SNAPSHOT');
const deleteCreditLines = generateTypes('MONITOR_CLIENT', 'DELETE_CREDIT_LINE');
const removeClientIntegration = 'platfi-ui-app/MONITOR_CLIENT/REMOVE_INTEGRATION';
const snapshotAccounts = generateTypes('MONITOR_CLIENT', 'SNAPSHOT_ACCOUNTS');
const updateSnapshotAccount = generateTypes('MONITOR_CLIENT', 'UPDATE_SNAPSHOT_ACCOUNT');
const updateSnapshotAccounts = generateTypes('MONITOR_CLIENT', 'UPDATE_SNAPSHOT_ACCOUNTS');
const archiveClient = generateTypes('MONITOR_CLIENT', 'ARCHIVE_CLIENT');
const deleteClient = generateTypes('MONITOR_CLIENT', 'DELETE_CLIENT');

const SET_SNAPSHOT_CREATING = 'platfi-ui-app/MONITOR_CLIENT/SET_SNAPSHOT_CREATING';
const CLOSE_BANK_DATA_LOADING_ERROR_MODAL =
  'platfi-ui-app/MONITOR_CLIENT/CLOSE_BANK_DATA_LOADING_ERROR_MODAL';
const CLOSE_BANK_DATA_LOADING_MODAL = 'platfi-ui-app/MONITOR_CLIENT/CLOSE_BANK_DATA_LOADING_MODAL';
const CLOSE_HEALTH_REPORT = 'platfi-ui-app/MONITOR_CLIENT/CLOSE_HEALTH_REPORT';
const CLOSE_CLIENT_PAGE = 'platfi-ui-app/MONITOR_CLIENT/CLOSE_CLIENT_PAGE';
const CLOSE_INVITE_CLIENT_MODAL = 'platfi-ui-app/MONITOR_CLIENT/CLOSE_INVITE_CLIENT_MODAL';
const OPEN_BANK_DATA_LOADING_ERROR_MODAL =
  'platfi-ui-app/MONITOR_CLIENT/OPEN_BANK_DATA_LOADING_ERROR_MODAL';
const OPEN_BANK_DATA_LOADING_MODAL = 'platfi-ui-app/MONITOR_CLIENT/OPEN_BANK_DATA_LOADING_MODAL';
const OPEN_INVITE_CLIENT_MODAL = 'platfi-ui-app/MONITOR_CLIENT/OPEN_INVITE_CLIENT_MODAL';
const OPEN_HEALTH_REPORT = 'platfi-ui-app/MONITOR_CLIENT/OPEN_HEALTH_REPORT';
const REMOVE_SNAPSHOT = 'platfi-ui-app/MONITOR_CLIENT/REMOVE_SNAPSHOT';
const SET_CURRENT_MONITOR_PAGE_CLIENT_ID =
  'platfi-ui-app/MONITOR_CLIENT/SET_CURRENT_MONITOR_PAGE_CLIENT_ID';
const SET_MONITOR_PAGE_TAB = 'platfi-ui-app/MONITOR_CLIENT/SET_MONITOR_PAGE_TAB';
const SET_MONITOR_CLIENT_BALANCE_SHEET_VIEW_TYPE =
  'platfi-ui-app/MONITOR_CLIENT/SET_MONITOR_CLIENT_BALANCE_SHEET_VIEW_TYPE';
const SET_MONITOR_CLIENT_BALANCE_SHEET_VIEW_TYPE_SUCCESS =
  'platfi-ui-app/MONITOR_CLIENT/SET_MONITOR_CLIENT_BALANCE_SHEET_VIEW_TYPE_SUCCESS';
const SSE_UPDATE_SNAPSHOT_GENERATION_PROGRESS = '@@SSE/entity/ledger/snapshot/generation';
const SET_NEW_EDIT_FLOW_CLIENT_DATA = 'platfi-ui-app/MONITOR_CLIENT/SET_NEW_EDIT_FLOW_CLIENT_DATA';

export {
  createSnapshot,
  removeClientIntegration,
  snapshot,
  snapshotAccounts,
  deleteCreditLines,
  updateSnapshotAccount,
  updateSnapshotAccounts,
  archiveClient,
  deleteClient,
  CLOSE_HEALTH_REPORT,
  CLOSE_BANK_DATA_LOADING_ERROR_MODAL,
  CLOSE_BANK_DATA_LOADING_MODAL,
  CLOSE_CLIENT_PAGE,
  CLOSE_INVITE_CLIENT_MODAL,
  OPEN_BANK_DATA_LOADING_ERROR_MODAL,
  OPEN_BANK_DATA_LOADING_MODAL,
  OPEN_HEALTH_REPORT,
  SET_CURRENT_MONITOR_PAGE_CLIENT_ID,
  SET_MONITOR_PAGE_TAB,
  OPEN_INVITE_CLIENT_MODAL,
  REMOVE_SNAPSHOT,
  SSE_UPDATE_SNAPSHOT_GENERATION_PROGRESS,
  SET_MONITOR_CLIENT_BALANCE_SHEET_VIEW_TYPE,
  SET_MONITOR_CLIENT_BALANCE_SHEET_VIEW_TYPE_SUCCESS,
  SET_SNAPSHOT_CREATING,
  SET_NEW_EDIT_FLOW_CLIENT_DATA,
};
